module.exports = __webpack_public_path__ + "static/img/7.024a19f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/7.png
// module id = NcA8
// module chunks = 0